export default {
  27: {
    x: 60.171,
    y: 104.951,
    type: 'quintessence',
  },
  28: {
    x: 417.671,
    y: 104.951,
    type: 'quintessence',
  },
  29: {
    x: 238.157,
    y: 414.789,
    type: 'quintessence',
  },
};
